import React from 'react';

export type TaskFieldLabelVariant = 'fixed' | 'col4';

interface TaskFieldRowProps {
  label: React.ReactNode;
  htmlFor?: string;
  labelVariant?: TaskFieldLabelVariant;
  spaced?: boolean;
  hasError?: boolean;
  errorMessage?: React.ReactNode;

  reserveErrorSpace?: boolean;
  children: React.ReactNode;
}

export const TaskFieldRow: React.FC<TaskFieldRowProps> = ({
  label,
  htmlFor,
  labelVariant = 'fixed',
  spaced = false,
  hasError = false,
  errorMessage,
  reserveErrorSpace = false,
  children
}) => {
  const labelClassName =
    labelVariant === 'col4'
      ? 'col-4 fixed-labels'
      : 'col-fixed fixed-labels task-card__label--fixed';

  return (
    <div
      className={`task-field-row flex flex-column${
        spaced ? ' task-field-row--spaced' : ''
      }`}
    >
      <div className="grid flex justify-content-between align-items-center gap-3">
        <label className={labelClassName} htmlFor={htmlFor}>
          {label}
        </label>
        {children}
      </div>
      {reserveErrorSpace ? (
        <p className="card-errors text-transparent"> </p>
      ) : (
        <p
          className={`card-errors ${
            hasError ? 'text-red-500' : 'text-transparent'
          }`}
        >
          {hasError ? errorMessage : ' '}
        </p>
      )}
    </div>
  );
};

export default TaskFieldRow;
